"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      serviceProviderStatus: [{}],
      pageName: 'serviceProvider',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        loginInStyle: '',
        loginCode: '',
        empNo: '',
        startTime: '',
        endTime: ''
      },
      lookupList: {}
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.getLookupTypeCode();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      this.$api.loginLog.getList(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this2 = this;
      var param = {
        configItemCodeList: ['LOGINLOG_STATUS']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this2.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this2.lookupList) {
          _this2.generateMapping(key, _this2.lookupList[key] || []);
        }
        _this2.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this3 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this3.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    resetData: function resetData() {
      this.searchVal = {
        loginInStyle: '',
        loginCode: '',
        empNo: '',
        startTime: '',
        endTime: ''
      };
      this.fetchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    }
  }
};